import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/descend.svg';
const Descend = () => React.createElement(IconSvg, null);
export default Descend;
